"use client";

import { c as _c } from "react/compiler-runtime";
import { TransferSingleActions } from "@/components/nft-transfer/TransferSingle";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { NFT, NftRank, NftTDH } from "@/entities/INFT";
import { CollectedCollectionType } from "@/entities/IProfile";
import type { ConsolidatedTDH } from "@/entities/ITDH";
import type { Transaction } from "@/entities/ITransaction";
import { numberWithCommas } from "@/helpers/Helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ContractType } from "@/types/enums";
import LatestActivityRow from "../latest-activity/LatestActivityRow";
function MemePageYourCardsTransferCard(props) {
  const $ = _c(20);
  const {
    isMobileDevice
  } = useDeviceInfo();
  const t0 = isMobileDevice ? "Your Cards" : "Cards";
  let t1;
  if ($[0] !== t0) {
    t1 = <span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-iron-500">{t0}</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `x${props.nftBalance}`;
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-white">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className="tw-inline-flex tw-items-baseline tw-gap-1.5 tw-whitespace-nowrap">{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.myRank || $[8] !== props.myTDH) {
    t5 = props.myRank && props.myTDH ? <><div className="tw-inline-flex tw-items-baseline tw-gap-1.5 tw-whitespace-nowrap"><span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-iron-500">TDH</span><span className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-white">{numberWithCommas(Math.round(props.myTDH.tdh))}</span></div><div className="tw-inline-flex tw-items-baseline tw-gap-1.5 tw-whitespace-nowrap"><span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-iron-500">Rank</span><span className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-white">#{props.myRank.rank}</span></div></> : <div className="tw-text-xs tw-font-medium tw-text-iron-500">No TDH accrued</div>;
    $[7] = props.myRank;
    $[8] = props.myTDH;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="tw-flex tw-w-full tw-flex-none tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-6 tw-gap-y-3 @lg:tw-w-auto @lg:tw-justify-start">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const statsContent = t6;
  let t7;
  if ($[13] !== isMobileDevice || $[14] !== props.nftBalance || $[15] !== props.transferNft) {
    t7 = !isMobileDevice && <div className="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-gap-x-6 @lg:tw-w-auto @lg:tw-flex-1"><div className="tw-hidden tw-h-10 tw-w-px tw-shrink-0 tw-bg-iron-800 @lg:tw-block" /><div className="tw-min-w-0 tw-flex-1"><TransferSingleActions collectionType={CollectedCollectionType.MEMES} contractType={ContractType.ERC1155} contract={MEMES_CONTRACT} tokenId={props.transferNft.id} max={props.nftBalance} title={(props.transferNft as {
          name?: string;
        }).name ?? `The Memes #${props.transferNft.id}`} thumbUrl={props.transferNft.thumbnail} /></div></div>;
    $[13] = isMobileDevice;
    $[14] = props.nftBalance;
    $[15] = props.transferNft;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== statsContent || $[18] !== t7) {
    t8 = <div className="tw-mb-3"><div className="tw-w-full tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-shadow-2xl tw-ring-1 tw-ring-white/5" data-testid="transfer-single"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-4 tw-px-4 tw-py-4 tw-@container">{statsContent}{t7}</div></div></div>;
    $[17] = statsContent;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
export function MemePageYourCardsRightMenu(props) {
  const $ = _c(11);
  if (!props.show) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const transferNft = props.nftBalance > 0 && props.myOwner && props.nft !== undefined && props.nft.id !== 0 ? props.nft : undefined;
  if (transferNft === undefined) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props.myRank || $[3] !== props.myTDH || $[4] !== props.nftBalance || $[5] !== props.transactions.length || $[6] !== props.wallets || $[7] !== transferNft) {
    t0 = props.transactions.length > 0 && props.wallets.length > 0 && <><MemePageYourCardsTransferCard transferNft={transferNft} nftBalance={props.nftBalance} myTDH={props.myTDH} myRank={props.myRank} /></>;
    $[2] = props.myRank;
    $[3] = props.myTDH;
    $[4] = props.nftBalance;
    $[5] = props.transactions.length;
    $[6] = props.wallets;
    $[7] = transferNft;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[9] !== t0) {
    t1 = <div className="tw-pt-6">{t0}</div>;
    $[9] = t0;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}
export function MemePageYourCardsSubMenu(props) {
  const $ = _c(5);
  if (!props.show) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== props.transactions) {
    t0 = props.transactions.length > 0 && <section><div className="tw-w-full tw-overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden"><table className="tw-min-w-full tw-border-separate tw-border-spacing-0"><tbody>{props.transactions.map(_temp)}</tbody></table></div></section>;
    $[1] = props.transactions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <>{t0}</>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(tr) {
  return <LatestActivityRow tr={tr} variant="tailwind" rowStyle="striped" key={`${tr.from_address}-${tr.to_address}-${tr.transaction}-${tr.token_id}`} />;
}